import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18v3h16v-14l-8 -4l-8 4v3","key":"svg-0"}],["path",{"d":"M4 14h9","key":"svg-1"}],["path",{"d":"M10 11l3 3l-3 3","key":"svg-2"}]]

/**
 * IconTransferIn
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJhbnNmZXItaW4iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTh2M2gxNnYtMTRsLTggLTRsLTggNHYzIiAvPgogIDxwYXRoIGQ9Ik00IDE0aDkiIC8+CiAgPHBhdGggZD0iTTEwIDExbDMgM2wtMyAzIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/transfer-in
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTransferIn = createReactComponent('outline', 'transfer-in', 'TransferIn', __iconNode);

export default IconTransferIn;